
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M75.9 86h22.6v3.3H75.9z"}}),_c('path',{staticClass:"st1",attrs:{"d":"M22.6 2H1.4C.8 2 .3 2.5.3 3.1v13.8c0 .6.5 1.1 1.1 1.1h8.8v2.5H6.8V22h10.3v-1.5h-3.3V18h8.8c.6 0 1.1-.5 1.1-1.1V3.1c0-.6-.5-1.1-1.1-1.1zM1.1 16.6l1.7-1.3h2.9L4 16.6H1.1zm4.2 0L7 15.4h10l1.7 1.3H5.3zm14.7 0l-1.6-1.3h2.9l1.7 1.3h-3z"}})])
          )
        }
      }
    